import React from "react";
import { themes } from "services/constants";
import { LoadingButton } from "@mui/lab";
import * as Mui from "@mui/material";

export const CustomButton = ({
  actionFuntion,
  actionName,
  typeName,
  disableAction,
  customTitleSx,
  customWidth,
  loading,
}) => {
  return (
    <LoadingButton
      onClick={actionFuntion}
      sx={{
        background: themes.primaryButton,
        textTransform: "capitalize",
        "&:hover": {
          backgroundColor: themes.primaryButton,
        },
        color: themes.headLine,
        fontWeight: "bold",
        ...customTitleSx,
        ...(customWidth && {
          width: 130,
        }),
      }}
      type={typeName}
      variant="contained"
      size="medium"
      loading={loading === undefined ? disableAction : loading}
      // loadingPosition="end"
      disabled={disableAction}
    >
      {actionName}
    </LoadingButton>
  );
};

export const CustomButtonWithOutLoader = ({
  actionFuntion,
  actionName,
  typeName,
  disableAction,
  customWidth,
  customTitleSx,
  AddIcon,
}) => {
  return (
    <LoadingButton
      onClick={actionFuntion}
      sx={{
        background: themes.primaryButton,
        textTransform: "capitalize",
        "&:hover": {
          backgroundColor: themes.primaryButton,
        },
        color: themes.headLine,
        fontWeight: "bold",
        ...customTitleSx,
        ...(customWidth && {
          width: 130,
        }),
      }}
      type={typeName}
      variant="contained"
      size="medium"
      disabled={disableAction}
    >
      {AddIcon && (
        <span style={{ marginRight: 5, display: "flex" }}>{AddIcon}</span>
      )}
      {actionName}
    </LoadingButton>
  );
};

export const CustomButtonWithBorder = ({
  actionFuntion,
  actionName,
  typeName,
  disableAction,
  customWidth,
  customTitleSx,
  AddIcon,
  handleColor,
}) => {
  return (
    <LoadingButton
      onClick={actionFuntion}
      sx={{
        backgroundColor: handleColor ? themes.redColor : themes.whiteColor,
        border: `1.5px solid ${
          handleColor ? themes.redColor : themes.greenColor
        }`,
        color: handleColor ? themes.whiteColor : themes.greenColor,
        fontWeight: "bold",
        textTransform: "capitalize",
        "&:hover": {
          backgroundColor: handleColor ? themes.redColor : themes.whiteSmoke,
          borderColor: handleColor ? themes.redColor : themes.greenColor,
        },
        ...customTitleSx,
        ...(customWidth && {
          width: 130,
        }),
      }}
      type={typeName}
      variant="outlined"
      size="medium"
      disabled={disableAction}
    >
      {AddIcon && (
        <span style={{ marginRight: 5, display: "flex" }}>{AddIcon}</span>
      )}
      {actionName}
    </LoadingButton>
  );
};

export const TableRowNoData = () => (
  <Mui.TableRow>
    <Mui.TableCell colSpan={12}>
      <Mui.Alert severity="info">No data available</Mui.Alert>
    </Mui.TableCell>
  </Mui.TableRow>
);

export const InfoMessage = ({ dataLength, rowHeight }) => {
  return (
    <Mui.TableRow sx={{ padding: 2, height: rowHeight ? "750px" : "none" }}>
      <Mui.TableCell colSpan={15}>
        <Mui.Alert severity="info">
          {dataLength?.length === 0
            ? "No data available."
            : "No matching data found for your search."}
        </Mui.Alert>
      </Mui.TableCell>
    </Mui.TableRow>
  );
};
